module.exports = __webpack_public_path__ + "static/media/dark_view.c6d45fe0.svg";